module.exports = __webpack_public_path__ + "assets/img/09.ab419e38.png";